import React from 'react';
import { Calendar, Clock, FileText } from 'lucide-react';
export function LeaveManagement() {
  // Mock data
  const leaveBalances = [{
    type: 'Congés payés',
    balance: 18,
    unit: 'jours'
  }, {
    type: 'RTT',
    balance: 5,
    unit: 'jours'
  }, {
    type: 'Maladie',
    balance: 3,
    unit: 'jours'
  }];
  const leaveHistory = [{
    id: 1,
    type: 'Congés payés',
    startDate: '2023-08-01',
    endDate: '2023-08-15',
    status: 'approved',
    days: 10
  }, {
    id: 2,
    type: 'RTT',
    startDate: '2023-10-13',
    endDate: '2023-10-13',
    status: 'approved',
    days: 1
  }, {
    id: 3,
    type: 'Congés payés',
    startDate: '2023-12-22',
    endDate: '2023-12-31',
    status: 'pending',
    days: 6
  }];
  return <div data-id="element-734">
      <div className="mb-8" data-id="element-735">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-736">
          Gestion des congés
        </h1>
        <p className="text-gray-600" data-id="element-737">Demandez et suivez vos congés</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-738">
        {/* Left column - Balance */}
        <div className="lg:col-span-1 space-y-6" data-id="element-739">
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-740">
            <div className="flex items-center justify-between mb-6" data-id="element-741">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-742">
                Solde de congés
              </h3>
              <Clock className="h-5 w-5 text-blue-600" data-id="element-743" />
            </div>
            <div className="space-y-4" data-id="element-744">
              {leaveBalances.map((leave, index) => <div key={index} className="flex justify-between items-center py-3 border-b border-gray-100 last:border-0" data-id="element-745">
                  <span className="text-sm font-medium text-gray-700" data-id="element-746">
                    {leave.type}
                  </span>
                  <div className="flex items-baseline" data-id="element-747">
                    <span className="font-bold text-2xl text-gray-900" data-id="element-748">
                      {leave.balance}
                    </span>
                    <span className="ml-1 text-sm text-gray-500" data-id="element-749">
                      {leave.unit}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-750">
            <div className="flex items-center justify-between mb-6" data-id="element-751">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-752">
                Demander un congé
              </h3>
              <FileText className="h-5 w-5 text-blue-600" data-id="element-753" />
            </div>
            <form className="space-y-4" data-id="element-754">
              <div data-id="element-755">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-756">
                  Type de congé
                </label>
                <select className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors" data-id="element-757">
                  <option data-id="element-758">Congés payés</option>
                  <option data-id="element-759">RTT</option>
                  <option data-id="element-760">Maladie</option>
                  <option data-id="element-761">Congé sans solde</option>
                </select>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-762">
                <div data-id="element-763">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-764">
                    Date de début
                  </label>
                  <div className="relative" data-id="element-765">
                    <input type="date" className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors appearance-none" data-id="element-766" />
                    <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" data-id="element-767" />
                  </div>
                </div>
                <div data-id="element-768">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-769">
                    Date de fin
                  </label>
                  <div className="relative" data-id="element-770">
                    <input type="date" className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors appearance-none" data-id="element-771" />
                    <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" data-id="element-772" />
                  </div>
                </div>
              </div>
              <div data-id="element-773">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-774">
                  Commentaire (optionnel)
                </label>
                <textarea rows={3} className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors resize-none" data-id="element-775"></textarea>
              </div>
              <button type="submit" className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-base font-medium shadow-sm hover:shadow transition-all" data-id="element-776">
                Soumettre la demande
              </button>
            </form>
          </div>
        </div>
        {/* Right column - Calendar and History */}
        <div className="lg:col-span-2 space-y-6" data-id="element-777">
          <div className="bg-white rounded-lg shadow-sm p-5" data-id="element-778">
            <div className="flex items-center justify-between mb-4" data-id="element-779">
              <h3 className="font-semibold text-gray-900" data-id="element-780">
                Calendrier des congés
              </h3>
              <Calendar className="h-5 w-5 text-blue-600" data-id="element-781" />
            </div>
            <div className="h-64 border border-gray-200 rounded-md flex items-center justify-center" data-id="element-782">
              <p className="text-gray-500" data-id="element-783">
                Calendrier interactif (placeholder)
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-5" data-id="element-784">
            <div className="flex items-center justify-between mb-4" data-id="element-785">
              <h3 className="font-semibold text-gray-900" data-id="element-786">
                Historique des demandes
              </h3>
              <FileText className="h-5 w-5 text-blue-600" data-id="element-787" />
            </div>
            <div className="overflow-x-auto" data-id="element-788">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-789">
                <thead className="bg-gray-50" data-id="element-790">
                  <tr data-id="element-791">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-792">
                      Type
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-793">
                      Période
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-794">
                      Jours
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-795">
                      Statut
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-796">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-797">
                  {leaveHistory.map(leave => <tr key={leave.id} data-id="element-798">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-799">
                        {leave.type}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-800">{`${leave.startDate} - ${leave.endDate}`}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-801">
                        {leave.days}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-802">
                        <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${leave.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-803">
                          {leave.status === 'approved' ? 'Approuvé' : 'En attente'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-804">
                        {leave.status === 'pending' && <button className="text-red-600 hover:text-red-900" data-id="element-805">
                            Annuler
                          </button>}
                        {leave.status === 'approved' && <button className="text-blue-600 hover:text-blue-900" data-id="element-806">
                            Détails
                          </button>}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}